interface ItemProps {
  item: string;
}

export const Item = ({ item }: ItemProps) => (
  <div className="flex flex-col">
    <span className="text-sm font-medium">{item}</span>
  </div>
)
